/* eslint-disable import/prefer-default-export */
export const filterBuilderMixin = {
  methods: {
    buildFilter(filterObjects) {
      // Incoming object example: [{ property: 'Name', comparator: 'eq', value: nameFilter }, { ... }]
      if (!filterObjects || !filterObjects.length) return null;
      // 1. For each object in the array, create a filterString
      const filterStrings = [];
      filterObjects.forEach(o => {
        const filterValue = encodeURIComponent(o.value);
        filterStrings.push(`${o.property}:${o.comparator}:${filterValue}`);
      })
      // 2. Concatenate with bar and return
      return filterStrings.join('|');
    }
  }
}
